import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/app/news/NewsClient.tsx");
